import sv from './sv.js'

const eng = {}

Object.keys(sv).forEach(key => { eng[key] = key })

export default eng
